import { render, staticRenderFns } from "./web-table-columns-modal.vue?vue&type=template&id=5462ec56&"
import script from "./web-table-columns-modal.vue?vue&type=script&lang=js&"
export * from "./web-table-columns-modal.vue?vue&type=script&lang=js&"
import style0 from "./web-table-columns-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports